import { Accordion, AccordionDetails, AccordionSummary, Chip, Typography } from "@material-ui/core"
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';

import { useSectionStyles } from "./styles"
import { AwardCard } from './AwardCard';
import { EntryDivisionAward } from "../../types.results.reignite";

type AwardsSectionProps = {
  awards: EntryDivisionAward[]
  depth: number
  id: string | number
  isExpanded: boolean
  title: string
  type: 'gun' | 'chip'
  onToggleExpand: (id: string | number) => void
}

const AwardsSection = ({
  awards,
  depth,
  id,
  isExpanded,
  title,
  type,
  onToggleExpand,
}: AwardsSectionProps) => {
  const finalAwardsCount = awards.length

  const sectionStatus = awards.length >= depth ? 'active' : 'pending'

  const styles = useSectionStyles({ status: sectionStatus })

  return (
    <div>
      <Accordion
        className={styles.accordion}
        expanded={isExpanded}
        onChange={() => onToggleExpand(id)}
      >
        <AccordionSummary className={styles.accordionSummary} expandIcon={<ExpandMoreIcon />}>
          <Typography className={styles.title}>{title}</Typography>

          <Chip
            label={sectionStatus === 'pending' ? awards.length : `${finalAwardsCount}/${awards.length}`}
            variant='outlined'
            size='small'
            className={styles.chip}
          />

          <Chip
            label={type === 'chip' ? 'Chip Time' : 'Gun Time'}
            variant='outlined'
            size='small'
            className={styles.chip}
          />
        </AccordionSummary>

        <AccordionDetails>
          {sectionStatus === 'active' && (
            <div className={styles.warningContainer}>
              <ReportProblemOutlinedIcon />

              <Typography className={styles.warningText}>
                Scoring is still in progress. Awards are unofficial and may change.
              </Typography>
            </div>
          )}

          <div className={styles.cardsWrapper}>
            {awards.map((award) => <AwardCard
              key={award.id}
              award={award}
              status={sectionStatus}
              title={title}
            />)}
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  )
}

export { AwardsSection }